/**************************************************
 * Nombre:       Motivacion_RG
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import TituloPeqGrande from "../../../Componentes/TituloPeqGrande";
import {LiveTv} from '@mui/icons-material'
import Tarjeta_Estadistica from "../../../Tarjetas/Tarjeta_Estadistica";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Motivacion_RG = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 6}}>
                            <TituloPeqGrande peq={'¿Por que'} grande={'Deberías estar ahí?'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}}>
                            <Typography sx={{fontWeight: 400, fontSize: 16, textAlign: 'left', lineHeight: 1.2}}>
                                {item.parrafoOportunidad}
                            </Typography>
                        </Grid>


                    </Grid>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{mt: 10}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 3 : 6}
                    >

                        {item && item.resultados && item.resultados.map((resultado, index) => {
                            return (
                                <Grid container size={{xs: 6, sm: 4, md: 3}}>
                                    <Tarjeta_Estadistica resultado={resultado}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Motivacion_RG

const estadisticas = [
    {
        icono: LiveTv,
        titulo: 'Branding con propósito',
    },
    {
        icono: LiveTv,
        titulo: 'Branding con propósito',
    },
    {
        icono: LiveTv,
        titulo: 'Branding con propósito',
    },
    {
        icono: LiveTv,
        titulo: 'Branding con propósito',
    },
]
